import { Graph } from '@vromo/api/graph';

import { runInAction } from 'mobx';

import { LocalStorage } from '@vromo/models';
import { useStore } from '@vromo/mobx-react/mobx-react';
import { RootStore } from '../../dashboard/src/stores/RootStore';

import Tracking from '@vromo/analytics';
import { Coords } from '@vromo/models';
import { localServer, VromoSessionTokenKEY, prodBackend, secrets, TraySessionTokenKEY } from '@vromo/api/constants'

declare let localStorage: {
    [VromoSessionTokenKEY]?: string | null;
    [TraySessionTokenKEY]?: string | null;
};

export type Auth = {
    authenticated: boolean;
    login: (token: string) => Promise<boolean>;
    logout: () => Promise<void>;
    tok: string;
};

export default function useAuth(): [(token: string) => Promise<boolean>, () => void] {
    const rootStore = useStore<RootStore>('rootStore');

    const { authStore, viewStore } = rootStore;


    const login = async (token: string): Promise<boolean> => {
        const vromoGraph = new Graph(prodBackend, token);
        try {
            const { roles, user } = await vromoGraph.root.graph().get();
            localStorage[VromoSessionTokenKEY] = token;

            const currentRole =
                roles.items.find((it) => it.id === LocalStorage.role) ?? roles.items[0];

            authStore.login(user, roles.items, token, currentRole!);

            if (GIT_BRANCH !== 'master') window.Intercom('boot', {
                app_id: 'z96b9zc7',
                email: user?.contact?.email,
                user_id: user?.id,
                created_at: user?.created,
            });

            if (currentRole) {
                LocalStorage.role = currentRole.id;
            }

            await trackUserLocation()

            return true;
        }
        catch (err) {
            return false;
        }
    };

    const logout = async () => {
        const { graph } = authStore;

        await graph.root.logout().post({});

        rootStore.clear();
        LocalStorage.role = null;
        delete localStorage[TraySessionTokenKEY]
        delete localStorage[VromoSessionTokenKEY]
        if (GIT_BRANCH !== 'master') window.Intercom('shutdown');
        Tracking.logout();
        window.localStorage.clear();
    };

    const trackUserLocation = async () => {
        if (location.host !== localServer) {
            const response = await fetch(secrets.ipstack)
            if (response.ok) {
                const json = await response.json();

                const {
                    latitude,
                    longitude,
                    location: { calling_code },
                    country_code,
                    currency
                } = json;

                runInAction(() => {
                    viewStore.location = new Coords(latitude, longitude);
                    viewStore.callingCode = calling_code;
                    viewStore.country = country_code;
                    viewStore.currencyCode = currency.code;

                    if (viewStore.imperialUnits === null) {
                        viewStore.imperialUnits = country_code === 'US';
                    }
                });
            }
        }
    }

    return [login, logout];
}
